/**
 * @ngdoc module
 * @name angular-material-persian-datepicker
 * @description Module for the Persian datepicker component.
 */

angular.module('angular-material-persian-datepicker', [
  'material.core',
  'material.components.icon',
  'material.components.virtualRepeat'
]);



//////////////////
// WEBPACK FOOTER
// ./src/datePicker.js
// module id = 1
// module chunks = 0